import { render, staticRenderFns } from "./NewMessagesModal.vue?vue&type=template&id=55c7d576&"
import script from "./NewMessagesModal.vue?vue&type=script&lang=js&"
export * from "./NewMessagesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports